'use client'

import { useEffect, useRef } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'
import { installScriptBoundaryGuard, type LeftPage } from './script-boundary'

/**
 * Mounts the link-click and back/forward guard from `script-boundary.ts` once
 * for the whole site, and keeps it told which page is being left.
 *
 * Uses `useSearchParams`, so the caller wraps this in `<Suspense>`.
 */
export function ScriptBoundaryGuard() {
  const pathname = usePathname()
  const query = useSearchParams()?.toString() ?? ''
  const leftPage = useRef<LeftPage>({ url: '', state: null })

  useEffect(() => {
    leftPage.current = { url: window.location.href, state: window.history.state }
  }, [pathname, query])

  useEffect(() => installScriptBoundaryGuard(() => leftPage.current), [])

  return null
}
